import PropTypes from 'prop-types'

export default function VendorForm({children}) {
  return <div className="wrap--row margin-top-15">{children}</div>
}

VendorForm.propTypes = {
  children: PropTypes.node.isRequired,
}
